"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubFiscaliteApplicableScpiCorporationTrads = void 0;
exports.ESubFiscaliteApplicableScpiCorporationTrads = {
    dividendes: "Il s'agit essentiellement de la fiscalité des dividendes",
    neSaisPas: "Je ne sais pas",
    pasDeFiscalite: "Il n'y a pas de fiscalité sur les revenus perçus",
    revenusFonciers: "Il s'agit essentiellement de la fiscalité des revenus fonciers",
};
